import { render, staticRenderFns } from "./ManageLoan.vue?vue&type=template&id=c5acf6dc"
import script from "./ManageLoan.vue?vue&type=script&lang=js"
export * from "./ManageLoan.vue?vue&type=script&lang=js"
import style0 from "./ManageLoan.vue?vue&type=style&index=0&id=c5acf6dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports